import { createContext } from 'react';

const currencyContext = createContext();

export default currencyContext;